/**
 * Centralized configuration for Satu Event Tracker
 * Defines default event names, activity types, and tracking behavior
 */

/**
 * The main event name for all Satu Event Tracker events
 * Used as the eventName parameter in tracker calls
 */
export const SATU_EVENT_TRACKER_EVENT_NAME = 'guru_core_pwa_event_tracker_v1'

/**
 * Default event type for all tracking events
 * This is the top-level event name sent to the backend
 */
export const SATU_EVENT_DEFAULT_EVENT_TYPE = 'GURU_CORE_APP'
